import { Component, Fragment } from "react";

import { Card, Col, Divider, Row } from "antd";
import { FilterBarRedux } from "common/components/filterBar/FilterBar";
import { Modal } from "common/components/modal";
import { Tooltip } from "common/components/tooltip";
import classnames from "classnames";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePlus, faArrowToBottom } from "@fortawesome/pro-regular-svg-icons";

import { ExportDialog } from "./tableExport";
import { Breadcrumbs } from "./breadcrumbs";

import { ReportStatistic } from "./components/reportStatistic";

export class ReportHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exportVisible: false
        };
    }
    
    getExportOptions() {
        const filteredStr = this.props.filter !== "{}" ? "filtered_" : "";
        const canonicalNameList = this.props.id?.split("__");
        
        if (this.props.globalItemId !== null) {
            // This occurs when we're in a child report
            // and expect the parent id in the default name.
            canonicalNameList.splice(-1, 0, this.props.globalItemId);
        }
        const preparedName = canonicalNameList?.slice(1).join("__");
        const suggested_name = `${filteredStr}${preparedName}.csv`;
        return {
            // If export format options are added, add them here
            // the same way we do in transactionTables.js.
            suggested_name
        };
    }
    
    getColumnObjs() {
        return this.props.getColumnNames()?.map((name) => {
            const alias = this.props.grid_display_overrides?.find((override) => override.column_value === name)?.column_alias;
            return {
                name: alias || name,
                _id: name,
                collapsed_visible: true
            };
        });
    }
    
    showExport = () => this.setState({ exportVisible: true });
  
    hideExport = () => this.setState({ exportVisible: false });
  
    renderFilterActions() {
        if (this.props.filter === this.props.temp_filter && this.props.qualifiers === "") {
            return (
                <div className="actions">
                    {this.props.filter !== "{}" && <a href="#" className="pz-icon-text-button action-button" onClick={this.props.onClearFilter}>Clear</a>}
                    <a href="#" className="pz-icon-text-button action-button" onClick={this.props.onRefreshFilter}>Refresh</a>
                </div>
            );
        }
      
        return (
            <div className="actions">
                <a href="#" className="pz-icon-text-button action-button" onClick={this.props.onClearFilter}>Clear</a>
                <a href="#" className="pz-icon-text-button action-button" onClick={this.props.onApplyFilter}>Apply</a>
            </div>
        );
    }
    
    renderFilter() {
        if (this.props.id === "none" || this.props.itemId || this.props.parentSelectedAction?.format === "form_action") return null;
  
        let searchString;
      
        try {
            searchString = JSON.parse(this.props.temp_filter).search_string;
        } catch {
            searchString = "";
        }
      
        return (
            <div>
                {this.props.isSearchable && (
                    <div className="search">
                        <div className="reports-label">Search</div>
                        <div className="search-input">
                            <input className="form-control" type="text" value={searchString} onKeyPress={this.props.onKeyPressSearch} onChange={this.props.onSearchChange} />
                        </div>
                    </div>
                )}
                <div className="filter">
                    <div className="reports-label">Filter</div>
                    {this.props.filter_sources && (
                        <FilterBarRedux
                            sourcesOverride={(this.props.selectedAction === null || this.props.selectedAction.format === "grid_action") ? this.props.filter_sources : void 0}
                            qualifiers={this.props.qualifiers}
                            categoryModeAvailable={false}
                            onChange={(qualifiers) => this.props.onFilterBarUpdate(qualifiers.toString())}
                        />
                    )}
                    <textarea id="queryFilter" rows="2" className="form-control" value={this.props.temp_filter} onChange={this.props.onFilterChange}/>
                    {this.renderFilterActions()}
                </div>

            </div>
        );
    }
  
    renderBreadcrumbs() {
        return (
            <Breadcrumbs
                id={this.props.id}
                itemId={this.props.itemId}
                walk={this.props.walk}
                isLoading={this.props.isLoading}
                count={this.props.count}
                reportName={this.props.reportName}
                itemName={this.props.itemName}
                handleBreadcrumb={this.props.handleBreadcrumb}
            />
        );
    }
    
    renderChildReportInfo() {
        if (this.props.childReports === null || this.props.displayChildReport === null) return null;
        
        return (
            <div>
                <Row justify="end" gutter={12}>
                    {Object.values(this.props.childReports).map((childReport) => (
                        <Col>
                            <Card>
                                <ReportStatistic name={childReport.admin_report_name} count={childReport.count} />
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        );
    }
    
    renderExportDialog() {
        return (
            <Modal
                close={this.hideExport}
                header="Export results"
                portalId="modal-export-admin-report"
                show={this.state.exportVisible}
            >
                <ExportDialog
                    config={{ data: this.getColumnObjs() }}
                    exportOptions={this.getExportOptions()}
                    onExportClicked={this.props.exportHandler}
                    enableAutomaticDownload
                />
            </Modal>
        );
    }
    
    renderActions() {
        // Don't display actions in edit forms
        if (this.props.isLoading) return null;

        return (
            <div className="table-actions btn-group">

                {
                  // We're excluding cases with an itemId to prevent
                  // actions from showing in the detail view. This logic
                  // will need to change when we allow actions on details
                  // in cases where the related flag is present on the action.
                  this.props.report_action_configs && this.props.itemId === null && (
                  <ActionButtons
                      report_action_configs={this.props.report_action_configs}
                      assignItemsSize={this.props.assignItemsSize}
                      childReports={this.props.childReports}
                      onActionSelectedHandler={this.props.onActionSelectedHandler}
                      selectedAction={this.props.selectedAction}
                  />
                  )
}
                
                {this.props.childReports !== null && (
                    <Tooltip title="Show child reports">
                        <span className={classnames("action", "btn", "btn-default")} onClick={this.props.showAssignedItemsHandler}>
                            {this.props.displayChildReport ? "Hide" : "Show" } child reports
                        </span>
                    </Tooltip>
                )}
                {this.props.canCreateNew && (
                    <Tooltip title="Create new">
                        <span className="action btn btn-default" onClick={this.props.createNewHandler}>
                            <FontAwesomeIcon className="download-icon" icon={faFilePlus}/>
                        </span>
                    </Tooltip>
                )}

                {this.props.canExport && (
                <Tooltip title="Export results">
                    <span className="action btn btn-default" onClick={this.showExport}>
                        <FontAwesomeIcon className="download-icon" icon={faArrowToBottom}/>
                    </span>
                </Tooltip>
                )}
            </div>
        );
    }
  
    render() {
        return (
            <div className="report-header">
                {this.renderFilter()}
                {this.renderBreadcrumbs()}
                {this.renderActions()}
                {this.renderExportDialog()}
                {this.renderChildReportInfo()}
                <Divider />
            </div>
        );
    }
}

const ActionButtons = ({
    report_action_configs, assignItemsSize, childReports, onActionSelectedHandler, selectedAction
}) => report_action_configs.map((action, index) => {
    // Once selection_threshold is added on the backend this can be simplified to remove the undefined check.
    const belowSelectionThreshold = typeof action.selection_threshold === "undefined" ? assignItemsSize === 0 : assignItemsSize < action.selection_threshold;
    const disableAction = belowSelectionThreshold || selectedAction !== null;
    return (
        <Fragment key={action.action_key}>{["grid_action", "simple_action", "form_action", "combo_action"].includes(action.format) && (
        <Tooltip title={`${action.action_description}`} >
            <span className={classnames("action", "btn", "btn-default", { disabled: disableAction })} onClick={!disableAction ? () => { onActionSelectedHandler(index); } : () => {}}>
                {action.action_display_name} {typeof action.selection_threshold === "undefined" || action.selection_threshold > 0 ? `(${assignItemsSize})` : ""}
            </span>
        </Tooltip>
        )}
        </Fragment>
    );
});
